// generated from 4 samples

import { z } from "zod";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const hasConnectedTwitterFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("has_connected_twitter_filter"),
  comparison_key: z.literal("1"),
  display_name: z.string(),
  value: z.literal(true),
  varies_by_app_group: z.literal(false),
});
